export const createUrlWithQueryParams = (
  path: string,
  queryParams: Record<string, string | number | boolean | undefined>
) => {
  const host = process.env.NEXT_PUBLIC_HOST ?? 'http://localhost:3000'
  const url = new URL(host + path)
  const params = new URLSearchParams()

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined) params.append(key, String(value))
  })
  url.search = params.toString()
  return url.toString()
}

const isHttpProtocol = (url: URL) =>
  url.protocol === 'http:' || url.protocol === 'https:'

// ユーザーが入力した外部リンクを http(s) の URL に限定する
// javascript: URL などでスクリプトが実行されるのを防ぐため、許可しない値は null にする
export const toSafeHttpURL = (raw: string | null | undefined) => {
  if (raw === null || raw === undefined) return null
  try {
    const url = new URL(raw.trim())
    return isHttpProtocol(url) ? url.href : null
  } catch {
    return null
  }
}

// 外部から渡されたリダイレクト先を同一オリジンの http(s) URL に限定する
// javascript: URL や外部サイトへのリダイレクトを防ぐため、許可しない値は fallback にする
export const toSafeRedirectURL = (
  raw: string | null | undefined,
  fallback: string
) => {
  if (raw === null || raw === undefined || raw === '') return fallback

  const allowedOrigins = new Set<string>()
  if (process.env.NEXT_PUBLIC_HOST !== undefined) {
    allowedOrigins.add(new URL(process.env.NEXT_PUBLIC_HOST).origin)
  }
  if (typeof window !== 'undefined') {
    allowedOrigins.add(window.location.origin)
  }
  // window が使える場合は現在のオリジンを基準にする
  const base =
    typeof window !== 'undefined'
      ? window.location.origin
      : [...allowedOrigins][0]
  if (base === undefined) return fallback

  try {
    const url = new URL(raw, base)
    if (!isHttpProtocol(url)) return fallback
    if (!allowedOrigins.has(url.origin)) return fallback
    // パスが // で始まる場合にプロトコル相対 URL と解釈されないよう、
    // 現在のオリジンを先頭に付けた絶対 URL を返す
    return base + url.pathname + url.search + url.hash
  } catch {
    return fallback
  }
}
